// 设备框架配置文件
// 这个文件将由脚本自动更新

// 导入设备图片
// 移除缺失的资源引用
// import macbookpro from '@assets/macbookpro.png';
// import macbookair from '@assets/macbook-air-little.png';
// import imacpro from '@assets/imac.png';
// import ipadpro from '@assets/ipad.png';
// import iphonepro from '@assets/iphone.png';
import { windowDark, windowLight } from '@utils/windowsIcon';

// 使用占位符替代不存在的图片
const placeholder = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

const deviceFrames = {
  basicFrames: {
    titleKey: 'frame.basicFrames',
    items: [
      { id: 'none', nameKey: 'frame.none', type: 'basic' },
      { id: 'light', nameKey: 'frame.light', type: 'basic', bgColor: '#ffffff' },
      { id: 'dark', nameKey: 'frame.dark', type: 'basic', bgColor: '#000000' },
      { id: 'macosBarLight', nameKey: 'frame.macosBarLight', type: 'basic' },
      { id: 'macosBarDark', nameKey: 'frame.macosBarDark', type: 'basic' },
      { id: 'windowsBarLight', nameKey: 'frame.windowsBarLight', type: 'basic' },
      { id: 'windowsBarDark', nameKey: 'frame.windowsBarDark', type: 'basic' },
      { id: 'lightGray', nameKey: 'frame.lightGray', type: 'basic', bgColor: '#f5f5f5' },
      { id: 'darkGray', nameKey: 'frame.darkGray', type: 'basic', bgColor: '#333333' },
      { id: 'coloredBorder', nameKey: 'frame.coloredBorder', type: 'basic', bgColor: '#ffffff' },
      { id: 'gradientBorder', nameKey: 'frame.gradientBorder', type: 'basic' },
      { id: 'roundedCorners', nameKey: 'frame.roundedCorners', type: 'basic', bgColor: '#ffffff' },
      { id: 'shadowed', nameKey: 'frame.shadowed', type: 'basic', bgColor: '#ffffff' },
      { id: 'dottedBorder', nameKey: 'frame.dottedBorder', type: 'basic', bgColor: '#ffffff' },
      { id: 'heartDecorated', nameKey: 'frame.heartDecorated', type: 'basic', bgColor: '#ffffff' },
      { id: 'bubbleFrame', nameKey: 'frame.bubbleFrame', type: 'basic', bgColor: '#ffffff' },
      { id: 'starDecorated', nameKey: 'frame.starDecorated', type: 'basic', bgColor: '#ffffff' },
      { id: 'rainbowBorder', nameKey: 'frame.rainbowBorder', type: 'basic', bgColor: '#ffffff' },
    ]
  }
};

export default deviceFrames; 